/* eslint-disable */

import { Card, Col, Row } from "react-bootstrap";
import NextPrevLinks from "../../components/NextPrevLinks";
import EmotionCard from "../components/EmotionCard";
import EqqoPieChart from "../../EqqoPieChart";
import { useReport } from "../ReportContext";
import ChevronButton from "../components/ChevronButton";
import { useUser } from "../../UserContext";
import { useMemo } from "react";
import EmotionPercentile from "../components/EmotionPercentile";
import ScaleBarChart from "../components/ScaleBarChart";
import EclipseChart from "../components/EclipseChart";

import DisconnectedImage from "../../../assets/icons/disconnected.png";
import InterdependentImage from "../../../assets/icons/interdependent.png";
import IndependentImage from "../../../assets/icons/independent.png";
import DependantImage from "../../../assets/icons/dependent.png";
import { imageUrlsToImage } from "../../helpers/charts";
import { emotionToFields } from "../helpers/reportHelpers";
import { Link } from "react-router-dom";
import EmotionBadge from "../components/EmotionBadge";
import RSBadge from "../components/RSBadge";


const Summary = () => {
	const { reportContent: { acf: { summary }} } = useReport();
	const { respondent, respondentLoading } = useUser();

	const stats = useMemo(() => respondent?.weqProfile?.stats, [respondent]);
	const percentiles = useMemo(() => respondent?.weqProfile?.percentiles, [respondent]);

	const mostPleasantEmotion = useMemo(() => {
		if (!stats) return null;
		const emotions = [
			{ name: 'Joy', score: 'fJO_dist' },
			{ name: 'Love', score: 'fLO_dist' },
		];
		emotions.sort((a, b) => stats[b.score] - stats[a.score]);
		return emotions[0];
	}, [stats]);

	const mostDistressingEmotion = useMemo(() => {
		if (!stats) return null;
		const emotions = [
			{ name: 'Anger', score: 'fANG_dist' },
			{ name: 'Anxiety', score: 'fANX_dist' },
			{ name: 'Fear', score: 'fEA_dist' },
			{ name: 'Sadness', score: 'fSA_dist' },
			{ name: 'Shame', score: 'fSHA_dist' },
		];
		emotions.sort((a, b) => stats[b.score] - stats[a.score]);
		return emotions[0];
	}, [stats]);

	return respondentLoading
		? null
		: (
			<div className="report-view">
				<Row className="align-items-end mb-3">
					<Col dangerouslySetInnerHTML={{ __html: summary?.emotions?.description }} />
					<Col className="text-end" lg={4}>
						<ChevronButton as={Link} to="/report/emotions">{summary?.emotions?.button}</ChevronButton>
					</Col>
				</Row>

				<Row>
					<Col>
						<EmotionCard emotion={mostPleasantEmotion?.name} most score={stats[mostPleasantEmotion?.score] || 0} percentile={percentiles?.[mostPleasantEmotion?.score] || 0} />
					</Col>
					<Col>
						<EmotionCard emotion={mostDistressingEmotion?.name} most score={stats[mostDistressingEmotion?.score] || 0} percentile={percentiles?.[mostDistressingEmotion?.score] || 0} />
					</Col>
				</Row>

				<Card body className="bg-white my-4">
					<div dangerouslySetInnerHTML={{ __html: summary?.emotions?.pie_chart }} />
					<EqqoPieChart className="d-none d-lg-block" scores={[
						stats?.fANG_dist,
						stats?.fANX_dist,
						stats?.fEA_dist,
						stats?.fJO_dist,
						stats?.fLO_dist,
						stats?.fSA_dist,
						stats?.fSHA_dist]} />
					<Row className="d-lg-none d-md-flex d-sm-flex" md={2} sm={2}>
						{
							["Anger", "Anxiety", "Fear", "Joy", "Love", "Sadness", "Shame"].map(emotion => (
								<Col className="pb-3" key={emotion} style={{ maxWidth: '50%', minWidth: '50%' }}><EmotionBadge emotion={emotion} /></Col>
							))
						}
					</Row>
					<hr />
					<div dangerouslySetInnerHTML={{ __html: summary?.emotions?.compared_to_others }} />

					{
						Object.entries(emotionToFields).map(([emotion, stat]) => (
							<div key={emotion}>
								<EmotionPercentile emotion={emotion} percentile={percentiles?.[`${stat}_dist`] || 0} />
								{emotion === 'Shame' ? null : <hr />}
							</div>
						))
					}
				</Card>

				<Card body className="bg-white my-4">
					<h3>Access to Range of Feelings</h3>
					<ScaleBarChart value={percentiles?.feelings_Access} />
				</Card>

				<hr />

				<Row className="gap-sm-2 gap-md-0">
					<Col md={6} sm={12}>
						<div className="mb-2" dangerouslySetInnerHTML={{ __html: summary?.self_other_orientation?.description }} />
						<ChevronButton as={Link} to="/report/self-other">{summary?.self_other_orientation?.button}</ChevronButton>
					</Col>
					<Col md={6} sm={12}>
						<Card body className="bg-white">
							<EclipseChart
								percentile={respondent?.weqProfile?.percentiles?.self_Other_Focus_Balance}
								target="Target Focus - 50/50"
								values={[
									{ label: "Focus on Self", value: stats.self_Oriented_dist },
									{ label: "Focus on Other", value: stats.other_Oriented_dist }
								]}
							/>
						</Card>
					</Col>
				</Row>

				<hr />

				<Row>
					<Col lg={8} md={9}>
						<div dangerouslySetInnerHTML={{ __html: summary?.empathy_compassion?.description }} />
					</Col>
					<Col className="d-flex flex-column justify-content-end">
						<div className="text-end">
							<ChevronButton as={Link} to="/report/empathy-compassion">{summary?.empathy_compassion?.button}</ChevronButton>
						</div>
					</Col>
				</Row>

				<Card body className="bg-white my-4">
					<ScaleBarChart value={percentiles.eMC_sub_WTFS} />
				</Card>

				<hr />

				<Row>
					<Col lg={8} md={9}>
						<div dangerouslySetInnerHTML={{ __html: summary?.relationship_strategies?.description }} />
					</Col>
					<Col className="d-flex flex-column justify-content-end">
						<div className="text-end">
							<ChevronButton as={Link} to="/report/relationship-strategies">{summary?.relationship_strategies?.button}</ChevronButton>
						</div>
					</Col>
				</Row>

				<Card body className="my-4 bg-white">
					<EqqoPieChart
						className="d-none d-lg-block"
						colors={["#FFAE4C", "#8979FF", "#FF928A", "#3CC3DF"]}
						images={imageUrlsToImage([
							DisconnectedImage,
							InterdependentImage,
							IndependentImage,
							DependantImage
						])}
						labels={["Disconnected", "Interdependent", "Independent", "Dependent"]}
						options={{
							distFromCenter: 60
						}}
						scores={[
							stats.lSLO_dist,
							stats.hSO_dist,
							stats.hSLO_dist,
							stats.lSHO_dist,
						]} />
						<Row className="d-lg-none d-md-flex d-sm-flex align-items-center mb-2" md={2} sm={2}>
						{
							["Disconnected", "Interdependent", "Independent", "Dependent"].map((label, index) => (
								<Col className="mb-2" key={index}><RSBadge strategy={label} /></Col>
						))}
						</Row>
				</Card>

				<NextPrevLinks />
			</div>
		);
};

export default Summary;
